// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__EwVYi {
    background-color: var(--negroFooter);
    color: var(--textoBlanco);
    padding: 60px 20px 20px 20px;
}

.Footer_footerContenedor__NLjIc {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 40px;
}

.Footer_footer__EwVYi a, .Footer_footer__EwVYi p, .Footer_footer__EwVYi h3, .Footer_footer__EwVYi summary {
    color: var(--textoBlanco);
}

.Footer_footerColumnas__mOYOx summary, .Footer_footerColumnas__mOYOx h3 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
    cursor: pointer;
}

.Footer_footerColumnas__mOYOx ul {
    list-style: none;
    padding-left: 0;
}

.Footer_footerColumnas__mOYOx ul li {
    margin-bottom: 12px;
}

.Footer_footerColumnas__mOYOx a:hover {
    color: var(--azul);
    text-decoration: underline;
}

.Footer_footerColumnas__mOYOx i {
    margin-right: 8px;
    color: #ffffff;
}

.Footer_newsletterForm__Lqaym {
    display: flex;
    flex-direction: column;
}

.Footer_newsletterForm__Lqaym input {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid var(--borderColor);
    margin-bottom: 10px;
    background-color: #333;
    color: var(--textoBlanco);
}

.Footer_newsletterForm__Lqaym button {
    color: var(--textoBlanco);
    background-color: var(--naranja);
    border: none;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 600;
}

.Footer_newsletterForm__Lqaym button:hover {
    background-color: var(--azul);
}

.Footer_footerRedes__nc3Xb {
    grid-column: span 1; /* Ocupa una columna */
}

.Footer_columnaSocial__zsB2N i {
  font-size: 24px;
  margin-right: 15px;
  display: inline-block;
  color: #ffffff;
}

.Footer_columnaSocial__zsB2N i:hover {
  color: var(--azul);
}

.Footer_footerRedes__nc3Xb a {
    font-size: 24px;
    margin-right: 15px;
}

.Footer_copyright__QJwUC {
    grid-column: 1 / -1;
    text-align: center;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid var(--borderColor);
}

.Footer_copyright__QJwUC img {
    max-width: 150px;
    margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer.module.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB,EAAE,sBAAsB;AAC/C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":[".footer {\n    background-color: var(--negroFooter);\n    color: var(--textoBlanco);\n    padding: 60px 20px 20px 20px;\n}\n\n.footerContenedor {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 40px;\n}\n\n.footer a, .footer p, .footer h3, .footer summary {\n    color: var(--textoBlanco);\n}\n\n.footerColumnas summary, .footerColumnas h3 {\n    font-size: 18px;\n    font-weight: 700;\n    margin-bottom: 20px;\n    cursor: pointer;\n}\n\n.footerColumnas ul {\n    list-style: none;\n    padding-left: 0;\n}\n\n.footerColumnas ul li {\n    margin-bottom: 12px;\n}\n\n.footerColumnas a:hover {\n    color: var(--azul);\n    text-decoration: underline;\n}\n\n.footerColumnas i {\n    margin-right: 8px;\n    color: #ffffff;\n}\n\n.newsletterForm {\n    display: flex;\n    flex-direction: column;\n}\n\n.newsletterForm input {\n    padding: 10px;\n    border-radius: 5px;\n    border: 1px solid var(--borderColor);\n    margin-bottom: 10px;\n    background-color: #333;\n    color: var(--textoBlanco);\n}\n\n.newsletterForm button {\n    color: var(--textoBlanco);\n    background-color: var(--naranja);\n    border: none;\n    padding: 10px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-weight: 600;\n}\n\n.newsletterForm button:hover {\n    background-color: var(--azul);\n}\n\n.footerRedes {\n    grid-column: span 1; /* Ocupa una columna */\n}\n\n.columnaSocial i {\n  font-size: 24px;\n  margin-right: 15px;\n  display: inline-block;\n  color: #ffffff;\n}\n\n.columnaSocial i:hover {\n  color: var(--azul);\n}\n\n.footerRedes a {\n    font-size: 24px;\n    margin-right: 15px;\n}\n\n.copyright {\n    grid-column: 1 / -1;\n    text-align: center;\n    margin-top: 40px;\n    padding-top: 20px;\n    border-top: 1px solid var(--borderColor);\n}\n\n.copyright img {\n    max-width: 150px;\n    margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__EwVYi`,
	"footerContenedor": `Footer_footerContenedor__NLjIc`,
	"footerColumnas": `Footer_footerColumnas__mOYOx`,
	"newsletterForm": `Footer_newsletterForm__Lqaym`,
	"footerRedes": `Footer_footerRedes__nc3Xb`,
	"columnaSocial": `Footer_columnaSocial__zsB2N`,
	"copyright": `Footer_copyright__QJwUC`
};
export default ___CSS_LOADER_EXPORT___;
